import classNames from "classnames"

import styles from "../RereservationCompletePageV2.module.scss"

// サロンごとに設定された連絡用 URL (公式 LINE 等) がある場合に出す案内文.
// 文言をサロンごとに変える要件が無いため DB には持たせず、ここで固定で持つ.
// モックの改行位置どおりに行の配列で持ち、pre-line (styles.contact_guide) で
// 改行を反映する (RereservationPageV2.tsx の .multilineText と同じパターン).
// 1 行の文字列のままだとブラウザが狭い画面で任意の位置で折り返し、読みにくくなる.
const CONTACT_URL_GUIDE_LINES = [
	"キャンセルまたは日程変更をご希望の方は",
	"下記URLよりご連絡ください",
]
const CONTACT_URL_NOTE = "※予約店舗、お名前を入れてご連絡ください"
// 連絡用 URL を設定していないサロンに出す、本機能追加前からある標準の固定文言.
// (URL 案内の方が後から追加された例外的な表示で、これが元々の標準表示)
const CONTACT_URL_DEFAULT_NOTICE =
	"※ キャンセル又は日程変更をご希望の方は店舗に直接お電話ください"

type Props = {
	contactUrl: string | null | undefined
}

// 再予約完了画面の最下部に表示する連絡先案内.
// BE は contactUrl を加工せずそのまま返すため、判定は「値が来たかどうか」だけ.
const RereservationCompleteContactSection = ({ contactUrl }: Props) => {
	// 連絡用 URL が未設定のサロンは、従来どおりの電話案内を表示する.
	if (!contactUrl) {
		return (
			<div className={styles.contact_section}>{CONTACT_URL_DEFAULT_NOTICE}</div>
		)
	}

	return (
		<div
			className={classNames(
				styles.contact_section,
				styles.contact_section_with_link
			)}
		>
			<p className={styles.contact_guide}>
				{CONTACT_URL_GUIDE_LINES.join("\n")}
			</p>
			<p className={styles.contact_link}>
				<a href={contactUrl} target="_blank" rel="noopener noreferrer">
					{contactUrl}
				</a>
			</p>
			<p>{CONTACT_URL_NOTE}</p>
		</div>
	)
}

export default RereservationCompleteContactSection
